/*
  FILE:  assets/stickr-configurator-v2.js

  Load order in layout/theme.liquid just before </body>:
    {{ 'stickerPricing.js'            | asset_url | script_tag }}
    {{ 'stickr-configurator-v2.js'    | asset_url | script_tag }}
*/

(function () {
  'use strict';

  /* ─── Wrap ────────────────────────────────────────────────────── */
  var wrap = document.getElementById('slcConfigurator');

  /* ── Mobile topbar — appears when builder scrolls into view ── */
  (function initTopbar() {
    var topbar  = document.getElementById('slcMobTopbar');
    var builder = document.getElementById('slcConfigurator');
    if (!topbar || !builder) return;

    /* Measure theme header height */
    function getHeaderH() {
      var selectors = ['header.header', '.header__wrapper', '.site-header', 'header'];
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (el && el.offsetHeight > 20) return el.offsetHeight;
      }
      return 80;
    }

    /* Position topbar just below the theme header */
    function place() {
      if (window.innerWidth > 580) {
        topbar.classList.remove('slc-mob-topbar--visible');
        return;
      }
      topbar.style.top = (getHeaderH() + 4) + 'px';
    }

    /* Show topbar when builder scrolls up to just below the header —
       trigger fires when builder top reaches headerH + 10px from viewport top
       so the topbar appears right above "Choose Your Shape" */
    function check() {
      if (window.innerWidth > 580) return;
      var rect    = builder.getBoundingClientRect();
      var headerH = getHeaderH();
      if (rect.top <= headerH + 10) {
        topbar.classList.add('slc-mob-topbar--visible');
      } else {
        topbar.classList.remove('slc-mob-topbar--visible');
      }
    }

    setTimeout(place, 50);
    setTimeout(place, 300);
    window.addEventListener('resize', function () { place(); check(); });
    window.addEventListener('scroll', check, { passive: true });
    check();
  })();

  if (!wrap) {
    console.warn('[Stickr] slcConfigurator not found — aborting');
    return;
  }

  if (typeof calculatePrice !== 'function') {
    console.error('[Stickr] stickerPricing.js not loaded — check load order');
    return;
  }

  console.log('[Stickr] JS LOADED — wrap found, pricing engine ready');

  function $  (id)  { return document.getElementById(id); }
  function $$ (sel) { return wrap.querySelectorAll(sel); }

  /* ─── DOM refs (footer lives outside wrap — use $ not $$) ─────── */
  var sfShape     = $('sfShape');
  var sfCorners   = $('sfCorners');
  var sfSize      = $('sfSize');
  var sfFinish    = $('sfFinish');
  var sfBorder    = $('sfBorder');
  var sfQty       = $('sfQty');
  var sfPrice     = $('sfPrice');
  var sfEach      = $('sfEach');
  var sfActionBtn = $('sfActionBtn');
  var sfUploadBtn = $('sfUploadBtn');

  var proofNoBtn   = $('slcProofNoBtn');
  var proofNoCheck = $('slcProofNoCheck');
  var proofYesChk  = $('slcProofYesCheck');
  var notesInput   = $('slcNotes');
  var fileInput    = $('slcFile');
  var uploadZone   = $('slcUploadZone');
  var uploadLabel  = $('slcUploadLabel');

  /* Log which critical refs are missing */
  ['sfActionBtn','sfUploadBtn','slcFile','slcUploadZone',
   'slcCustomSizeToggle','slcCustomSizeRow',
   'slcCustomQtyToggle','slcCustomQtyRow','slcCustomQtyInput'].forEach(function (id) {
    if (!document.getElementById(id)) console.warn('[Stickr] NOT FOUND: #' + id);
  });

  /* ─── State ───────────────────────────────────────────────────── */
  var MIN_SIZE = 1;
  var MAX_SIZE = 9;

  var state = {
    shape:     'Square',
    corners:   'Sharp',
    sizeMode:  'preset',
    presetW:   null,
    presetH:   null,
    customW:   null,
    customH:   null,
    qtyMode:   'preset',
    presetQty: 10,
    customQty: null,
    finish:    'Matte',
    border:    'No Border',
    thickness: '',
    proof:     'Instant Production (No Proof)',
    price:     null,
  };

  function getWidth()  { return state.sizeMode === 'custom' ? state.customW  : state.presetW; }
  function getHeight() { return state.sizeMode === 'custom' ? state.customH  : state.presetH; }
  function getQty()    { return state.qtyMode  === 'custom' ? state.customQty : state.presetQty; }

  function getSizeError() {
    if (state.sizeMode !== 'custom') return null;
    if (state.customW && state.customW < MIN_SIZE) return 'Minimum custom size is 1 inch.';
    if (state.customH && state.customH < MIN_SIZE) return 'Minimum custom size is 1 inch.';
    if (state.customW && state.customW > MAX_SIZE) return 'Max size is ' + MAX_SIZE + '"';
    if (state.customH && state.customH > MAX_SIZE) return 'Max size is ' + MAX_SIZE + '"';
    return null;
  }

  function isReadyToPrice() {
    var w = getWidth(), h = getHeight(), q = getQty();
    if (getSizeError()) return false;
    return (
      typeof w === 'number' && w >= MIN_SIZE && w <= MAX_SIZE &&
      typeof h === 'number' && h >= MIN_SIZE && h <= MAX_SIZE &&
      typeof q === 'number' && q >= 10  && q <= 10000
    );
  }

  /* ─── Price ───────────────────────────────────────────────────── */
  function computePrice() {
    if (!isReadyToPrice()) { state.price = null; return; }
    try {
      state.price = calculatePrice(getWidth(), getHeight(), getQty());
    } catch (e) {
      console.error('[Stickr] calculatePrice error:', e);
      state.price = null;
    }
  }

  /* ─── Open/close panels ───────────────────────────────────────── */
  var sizeOpen = false;
  var qtyOpen  = false;

  function setCustomSizeOpen(open) {
    sizeOpen = open;
    var r = $('slcCustomSizeRow'), t = $('slcCustomSizeToggle');
    if (r) r.classList.toggle('slc-panel-open', open);
    if (t) t.classList.toggle('slc-expand-btn--open', open);
  }
  function setCustomQtyOpen(open) {
    qtyOpen = open;
    var r = $('slcCustomQtyRow'), t = $('slcCustomQtyToggle');
    if (r) r.classList.toggle('slc-panel-open', open);
    if (t) t.classList.toggle('slc-expand-btn--open', open);
  }
  function collapseCustomSize() { setCustomSizeOpen(false); }
  function collapseCustomQty()  { setCustomQtyOpen(false);  }

  /* Show Rounded Corners section only for Square and Rectangle */
  function updateRoundedSection() {
    var section      = document.getElementById('slcRoundedSection');
    var cornersField = document.getElementById('sfCornersField');
    var show = (state.shape === 'Square' || state.shape === 'Rectangle');
    if (section)      section.classList.toggle('slc-hidden', !show);
    if (cornersField) cornersField.classList.toggle('slc-hidden', !show);
  }

  /* ─── CLICK delegation ────────────────────────────────────────── */
  document.addEventListener('click', function (e) {

    var btn = e.target.closest('[data-group]');
    if (btn && wrap.contains(btn)) {
      var group = btn.dataset.group;
      var value = btn.dataset.value;

      wrap.querySelectorAll('[data-group="' + group + '"]').forEach(function (b) {
        b.classList.remove('slc-tile--active', 'slc-chip--active', 'slc-qty-chip--active',
                           'slc-corner-btn--active', 'slc-thickness-btn--active', 'slc-cut-card--active');
      });

      if (group === 'shape') {
        state.shape = value;
        btn.classList.add('slc-tile--active');
        updateRoundedSection();
      }
      if (group === 'corners') {
        state.corners = value;
        btn.classList.add('slc-corner-btn--active');
      }
      if (group === 'thickness') {
        state.thickness = value;
        btn.classList.add('slc-thickness-btn--active');
      }
      if (group === 'finish') { state.finish = value; btn.classList.add('slc-tile--active'); }
      if (group === 'border') {
        state.border = value;
        btn.classList.add('slc-cut-card--active');
      }
      if (group === 'proof') {
        state.proof = value;
        btn.classList.add('slc-tile--active');
        updateRoundedSection();
        updateProofChecks();
      }
      if (group === 'size') {
        state.sizeMode = 'preset';
        state.presetW  = parseFloat(btn.dataset.w);
        state.presetH  = parseFloat(btn.dataset.h);
        btn.classList.add('slc-chip--active');
        collapseCustomSize();
      }
      if (group === 'qty') {
        var qval = parseInt(value, 10);
        if (!isNaN(qval)) {
          state.qtyMode   = 'preset';
          state.presetQty = qval;
        }
        btn.classList.add('slc-qty-chip--active');
        var qi = $('slcCustomQtyInput');
        if (qi) qi.value = '';
        collapseCustomQty();
      }

      refresh();
      return;
    }

    /* ── Custom SIZE toggle ── */
    if (e.target.closest('#slcCustomSizeToggle')) {
      if (sizeOpen) {
        setCustomSizeOpen(false);
        state.sizeMode = 'preset';
      } else {
        setCustomSizeOpen(true);
        wrap.querySelectorAll('[data-group="size"]').forEach(function (b) {
          b.classList.remove('slc-chip--active');
        });
        state.sizeMode = 'custom';
      }
      refresh();
      return;
    }

    /* ── Custom QTY toggle ── */
    if (e.target.closest('#slcCustomQtyToggle')) {
      if (qtyOpen) {
        setCustomQtyOpen(false);
        state.qtyMode   = 'preset';
        state.customQty = null;
      } else {
        setCustomQtyOpen(true);
        wrap.querySelectorAll('[data-group="qty"]').forEach(function (b) {
          b.classList.remove('slc-qty-chip--active');
        });
        state.qtyMode = 'custom';
      }
      refresh();
      return;
    }

  }, true);

  /* ─── INPUT delegation ────────────────────────────────────────── */
  document.addEventListener('input', function (e) {
    var id = e.target.id;

    if (id === 'slcWidth') {
      var v = parseFloat(e.target.value);
      state.customW  = (!isNaN(v) && v > 0) ? v : null;
      state.sizeMode = 'custom';
      e.target.classList.toggle('slc-input-error',
        !!(state.customW && (state.customW < MIN_SIZE || state.customW > MAX_SIZE)));
      refresh();
    }

    if (id === 'slcHeight') {
      var hv = parseFloat(e.target.value);
      state.customH  = (!isNaN(hv) && hv > 0) ? hv : null;
      state.sizeMode = 'custom';
      e.target.classList.toggle('slc-input-error',
        !!(state.customH && (state.customH < MIN_SIZE || state.customH > MAX_SIZE)));
      refresh();
    }

    if (id === 'slcCustomQtyInput') {
      var val = parseInt(e.target.value, 10);
      if (!e.target.value.trim() || isNaN(val) || val < 10) {
        state.customQty = null;
        state.qtyMode   = 'preset';
      } else {
        state.customQty = val;
        state.qtyMode   = 'custom';
        wrap.querySelectorAll('[data-group="qty"]').forEach(function (b) {
          b.classList.remove('slc-qty-chip--active');
        });
      }
      refresh();
    }
  });

  /* ─── Notes textarea auto-expand ─────────────────────────────── */
  var notesTextarea = document.getElementById('slcNotes');
  if (notesTextarea) {
    notesTextarea.addEventListener('input', function () {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
    });
  }

  /* ─── Proof checkmarks ────────────────────────────────────────── */
  function updateProofChecks() {
    var isInstant = (state.proof === 'Instant Production (No Proof)');
    if (proofNoCheck) proofNoCheck.classList.toggle('slc-hidden', !isInstant);
    if (proofYesChk)  proofYesChk.classList.toggle('slc-hidden',  isInstant);
  }

  /* ─── File upload ─────────────────────────────────────────────── */
  if (fileInput) {
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      if (f) { showUploadPreview(f); }
      else    { clearUploadPreview(); }
    });
  }

  function showUploadPreview(f) {
    var empty   = document.getElementById('slcUploadEmpty');
    var preview = document.getElementById('slcUploadPreview');
    var img     = document.getElementById('slcPreviewImg');
    var name    = document.getElementById('slcPreviewName');
    var size    = document.getElementById('slcPreviewSize');

    if (name) name.textContent = f.name;
    if (size) size.textContent = f.size < 1024 * 1024
      ? (f.size / 1024).toFixed(1) + ' KB'
      : (f.size / 1024 / 1024).toFixed(2) + ' MB';

    if (img) {
      var isImage = f.type.indexOf('image/') === 0;
      if (isImage) {
        var reader = new FileReader();
        reader.onload = function (e) { img.src = e.target.result; img.style.display = 'block'; };
        reader.readAsDataURL(f);
      } else {
        img.src = ''; img.style.display = 'none';
      }
    }

    if (empty)      empty.classList.add('slc-hidden');
    if (preview)    preview.classList.remove('slc-hidden');
    if (uploadZone) uploadZone.style.cursor = 'default';
    if (sfUploadBtn) sfUploadBtn.classList.add('slc-uploaded');
  }

  function clearUploadPreview() {
    var empty   = document.getElementById('slcUploadEmpty');
    var preview = document.getElementById('slcUploadPreview');
    var img     = document.getElementById('slcPreviewImg');
    if (img)     img.src = '';
    if (empty)   empty.classList.remove('slc-hidden');
    if (preview) preview.classList.add('slc-hidden');
    if (uploadZone)  uploadZone.style.cursor = 'pointer';
    if (fileInput)   fileInput.value = '';
    if (uploadLabel) uploadLabel.textContent = 'Drag and drop your file here';
    if (sfUploadBtn) sfUploadBtn.classList.remove('slc-uploaded');
  }

  /* Remove button */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#slcPreviewRemove')) { clearUploadPreview(); }
  });

  if (uploadZone) {
    uploadZone.addEventListener('dragover', function (e) {
      e.preventDefault(); uploadZone.classList.add('slc-over');
    });
    uploadZone.addEventListener('dragleave', function () {
      uploadZone.classList.remove('slc-over');
    });
    uploadZone.addEventListener('drop', function (e) {
      e.preventDefault();
      uploadZone.classList.remove('slc-over');
      var f = e.dataTransfer.files[0];
      if (f && fileInput) {
        try { var dt = new DataTransfer(); dt.items.add(f); fileInput.files = dt.files; } catch (_) {}
        showUploadPreview(f);
      }
    });
  }

  if (sfUploadBtn && fileInput) {
    sfUploadBtn.addEventListener('click', function () { fileInput.click(); });
  }

  /* ─── Refresh ─────────────────────────────────────────────────── */
  function refresh() {
    computePrice();
    updateFooter();
    if (sfActionBtn) sfActionBtn.disabled = !isReadyToPrice();
  }

  /* Write value to both mobile topbar and desktop footer */
  function setField(id, val) {
    var el = document.getElementById(id);
    if (el) el.textContent = val;
    var el2 = document.getElementById(id + 'Desk');
    if (el2) el2.textContent = val;
  }

  function updateFooter() {
    var w = getWidth(), h = getHeight(), q = getQty();
    setField('sfShape',  state.shape  || '--');
    if (sfCorners) sfCorners.textContent = state.corners || 'Sharp';
    setField('sfFinish', state.finish || '--');
    if (sfBorder) sfBorder.textContent = state.border || '--';
    var sfBD = document.getElementById('sfBorderDesk');
    if (sfBD) sfBD.textContent = state.border || '--';
    setField('sfSize', (w && h) ? (w + '" x ' + h + '"') : '--');
    setField('sfQty',  (q && q >= 10) ? String(q) : '--');

    var err = getSizeError();

    var priceBlock = document.getElementById('slcFooter');
    if (priceBlock) {
      priceBlock.classList.add('slc-price-updating');
      setTimeout(function () { priceBlock.classList.remove('slc-price-updating'); }, 120);
    }

    if (sfPrice) {
      sfPrice.textContent = err ? 'Max 9"' : (state.price !== null ? '$' + state.price.toFixed(2) : '--');
      sfPrice.style.color = err ? '#ff5f5f' : '';
    }
    if (sfEach) {
      if (err) {
        sfEach.textContent = err;
        sfEach.style.color = '#ff5f5f';
      } else if (state.price !== null && w && h && q) {
        sfEach.style.color = '';
        try { sfEach.textContent = '$' + pricePerSticker(w, h, q).toFixed(2) + ' each'; }
        catch (_) { sfEach.textContent = ''; }
      } else {
        sfEach.style.color = '';
        sfEach.textContent = '';
      }
    }
  }

  /* ─── Add to Cart ─────────────────────────────────────────────── */
  if (sfActionBtn) {
    sfActionBtn.addEventListener('click', function () {
      if (sfActionBtn.disabled) return;
      handleAddToCart();
    });
  }

  function resolveVariantId() {
    var raw = wrap.getAttribute('data-variant-id');
    var id  = raw ? parseInt(raw, 10) : NaN;
    if (!isNaN(id) && id > 0) return id;
    try {
      var v = window.ShopifyAnalytics.meta.product.variants;
      if (v && v.length) return parseInt(v[0].id, 10);
    } catch (_) {}
    return null;
  }

  function handleAddToCart() {
    var variantId = resolveVariantId();
    if (!variantId) {
      console.error('[Stickr] variant ID not found');
      alert('Could not add to cart — product variant not found. Please refresh.');
      return;
    }
    if (!isReadyToPrice()) {
      alert('Please complete all selections before adding to cart.');
      return;
    }

    setLoading(true);

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id:       variantId,
          quantity: 1,
          properties: {
            'Shape':            state.shape,
            'Corners':          state.corners,
            'Size':             getWidth() + '" x ' + getHeight() + '"',
            'Sticker Quantity': String(getQty()),
            'Finish':           state.finish,
            'Cut':              state.border,
            'Production':       state.proof,
            'Notes':            (notesInput && notesInput.value.trim()) || '',
            '_price':           '$' + (state.price || 0).toFixed(2),
          }
        }]
      })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (d) {
          throw new Error(d.description || d.message || 'HTTP ' + res.status);
        }).catch(function (err) {
          if (err.message && err.message.indexOf('HTTP') === 0) throw err;
          throw new Error('Cart error: HTTP ' + res.status);
        });
      }
      window.location.href = '/cart';
    }).catch(function (err) {
      console.error('[Stickr] Cart add failed:', err.message);
      alert('Could not add to cart: ' + err.message + ' — Please try again.');
      setLoading(false);
    });
  }

  function setLoading(on) {
    if (!sfActionBtn) return;
    sfActionBtn.disabled      = on;
    sfActionBtn.style.opacity = on ? '0.5' : '';
  }

  /* ─── Init ────────────────────────────────────────────────────── */
  (function init() {
    var firstSize = wrap.querySelector('[data-group="size"]');
    if (firstSize) {
      firstSize.classList.add('slc-chip--active');
      state.presetW = parseFloat(firstSize.dataset.w);
      state.presetH = parseFloat(firstSize.dataset.h);
    }

    var firstQty = wrap.querySelector('[data-group="qty"]');
    if (firstQty) {
      firstQty.classList.add('slc-qty-chip--active');
      var q = parseInt(firstQty.dataset.value, 10);
      if (!isNaN(q)) state.presetQty = q;
    }

    updateRoundedSection();
    updateProofChecks();
    if (proofNoBtn) proofNoBtn.classList.add('slc-tile--active');

    setCustomSizeOpen(false);
    setCustomQtyOpen(false);

    refresh();
  })();

})();